var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('query-form',{ref:"queryForm",attrs:{"fields":_vm.fields,"hasBtnBar":false,"actDisabled":_vm.actDisabled},on:{"submit":_vm.handleQuery,"reset":_vm.handleReset}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }